/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetLecturerSlotsParams = {
  lecturer_id?: string | null;
  include_cancelled?: boolean;
  startAfter?: string | null;
  endBefore?: string | null;
};
